import {FormModel} from "./form.model.abstract";
import {ValidatorFn} from "@angular/forms";

/**
 * Selection of a value with select dropdown
 * @inheritDoc
 */
export class FormModelSelect extends FormModel {

  /**
   * @inheritDoc
   */
  public type = 'select';

  /**
   * @inheritDoc
   * @param id
   * @param options List of selectable options
   * @param validators
   * @param unit
   * @param value
   * @param info
   */
  constructor(id: string, options: string[], validators: ValidatorFn[] = [], unit: string = null, value: any = "", info: boolean = true) {
    super(id, validators, unit, value, info);

    this.options = options;
  }

  /**
   * get a clone of the current object
   */
  public clone(): FormModelSelect {
    // @ts-ignore
    return new this.constructor(this.id, this.options, this.validators, this.unit, this.value, this.info);
  }

  /**
   * Returns the options, concated with an ampty option at the beginning.
   * @inheritDoc
   */
  getOptions(): string[] {
    return [""].concat(super.getOptions());
  }
}
